<div [tabindex]="disabled ? -1 : 0"
     class="tsq-switch pointer-cursor focus:outline"
     [attr.isOn]="abstractControl.value"
     [attr.disabled]="disabled"
     (click)="toggleSelected()"
     (keyup.Space)="toggleSelected()">
  <div class="switch-path"></div>
  <div class="switch-ellipse"></div>
</div>
